import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSettingWithFilter as asyncGetSettingWithFilter,
  getSettingWithIDS as asyncGetSettingWithId,
  updateSetting as asyncUpdateSetting,
  createSetting as asyncCreateSetting,
  deleteSetting as asyncDeleteSetting,
} from "../../helpers/apis";
import { toast } from 'react-toastify';
import { showToast } from "../toast/reducer";

// Thunk for fetching settings with filter
export const getSettingWithFilter = createAsyncThunk(
  "getCandidateResultWithFilter",
  async (req, thunkAPI) => {
    try {
      // Send pagination and filter params to the API request
      const { currentPage = 1, perPage = 20, ...filters } = req; // Ensure pagination is included
      const response = await asyncGetSettingWithFilter({
        ...filters,
        currentPage,
        perPage,
      });
      console.log("Fetched candidate results thunk:", response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(
        showToast({ type: "error", msg: error?.msg || "Error fetching candidate results" })
      );
      throw error;
    }
  }
);

// Thunk for creating a setting
export const createSetting = createAsyncThunk(
  "createSetting",
  async (data, thunkAPI) => {
    console.log(data);
    try {
      const response = await asyncCreateSetting(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg || "Setting created successfully!" }));
      console.log(response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error creating setting" }));
      throw error;
    }
  }
);

// Thunk for updating a setting
export const updateSetting = createAsyncThunk(
  "updateSetting",
  async (data, thunkAPI) => {
    try {
      console.log("update DATA:::::->->", data);
      const response = await asyncUpdateSetting(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg || "Setting updated successfully" }));
      console.log("update::::->", response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg || error.message || "Error updating setting" }));
      throw error;
    }
  }
);

// Thunk for fetching single setting by ID
export const getSettingWithIDS = createAsyncThunk(
  "getSettingWithId",
  async (id, thunkAPI) => {
    console.log("SETTING ID::::0".id);
    try {
      const response = await asyncGetSettingWithId(id);
      console.log(response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error fetching setting by ID" }));
      throw error;
    }
  }
);

// Thunk for deleting a setting
export const deleteSetting = createAsyncThunk(
  "deleteSetting",
  async (req, thunkAPI) => {
    try {
      const response = await asyncDeleteSetting(req);
      toast.success("Setting deleted successfully!");
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg }));
      throw error;
    }
  }
);

// Thunk for bulk deleting settings
export const bulkDeleteSetting = createAsyncThunk(
  "bulkDeleteSetting",
  async (data, thunkAPI) => {
    try {
      const response = await asyncBulkDeleteSetting(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
      return data.settingIds;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg }));
      throw error;
    }
  }
);
